// NOTE: Lovable generates this file. The ONLY local change is the auth `storage`
// adapter (crossSubdomainStorage) — needed so operator-login sessions survive the
// redirect across *.digavouch.com subdomains (Model B). If Lovable regenerates
// this file and reverts `storage` to localStorage, re-apply these two lines or
// cross-subdomain login breaks (operators re-login after each org redirect).
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { crossSubdomainStorage } from './crossSubdomainStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: crossSubdomainStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});